"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgHumax(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 5, y: 14, width: 30, height: 12, rx: 2, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M23 21a1 1 0 100-2 1 1 0 000 2z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M29 22a2 2 0 100-4 2 2 0 000 4z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0)] }), void 0));
}
exports.default = SvgHumax;
//# sourceMappingURL=Humax.js.map